/**
 * @generated SignedSource<<1bf3401344813a938315cca7608ff8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FirstColumnCell$data = {
  readonly canHaveChildIssues?: boolean | null | undefined;
  readonly hasChildren?: boolean | null | undefined;
  readonly node: {
    readonly issueId: string;
  } | null | undefined;
  readonly " $fragmentType": "FirstColumnCell";
};
export type FirstColumnCell$key = {
  readonly " $data"?: FirstColumnCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstColumnCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "FirstColumnCell",
  "selections": [
    {
      "condition": "shouldQueryHasChildren",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "filterByProjectKeys",
              "variableName": "projectKeys"
            }
          ],
          "kind": "ScalarField",
          "name": "hasChildren"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectKey",
              "variableName": "projectKey"
            }
          ],
          "kind": "ScalarField",
          "name": "canHaveChildIssues"
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "issueId"
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "3cdfef30b98027986ca5f2832216e2e7";

export default node;
